module.exports = __webpack_public_path__ + "assets/img/3.f9c7b254.jpg";